import { Typography } from '@mui/material'
import React from 'react'

export const SquareMetersLabel = ({
  children
}: {
  children: React.ReactNode
}) => (
  <Typography
    variant='caption'
    fontWeight='fontWeightBold'
    sx={{ minWidth: '50px', textAlign: 'right' }}>
    {children}
    {' m'}
    <sup>{'2'}</sup>
  </Typography>
)
